module.exports = __webpack_public_path__ + "img/useFlow-small-bg.f0800f9.png";